if (!customElements.get('dut-shipping-progress')) {
  customElements.define('dut-shipping-progress', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('script').textContent).variants;
      this.abort = new AbortController();
      this.form = document.getElementById(this.dataset.form);
      this.host = this.closest('product-info') || this.closest('section');
      const signal = this.abort.signal;
      this.host?.addEventListener('change', () => setTimeout(() => this.render(), 0), { signal });
      window.addEventListener('dut:cart-data', event => { this.cart = event.detail; this.render(); }, { signal });
      window.addEventListener('focus', () => this.refresh(), { signal });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          if (String(event.data.sectionId) === this.dataset.section) {
            this.dataset.variant = String(event.data.variant.id);
            this.render();
          }
        });
      }
      this.refresh();
    }
    async refresh() {
      const version = this.version = (this.version || 0) + 1;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store', signal: this.abort.signal });
        if (!response.ok) return;
        const cart = await response.json();
        if (version !== this.version) return;
        this.cart = cart;
        this.render();
      } catch (_) { /* Retain the server-rendered estimate if the cart cannot be read. */ }
    }
    render() {
      if (!this.cart) return;
      const id = Number(this.form?.querySelector('[name="id"]')?.value || this.dataset.variant);
      const variant = this.variants.find(item => item.id === id);
      if (!variant || !variant.available || this.cart.currency !== 'AUD') { this.hidden = true; return; }
      this.hidden = false;
      const quantity = Math.max(1, Number(this.host?.querySelector('[name="quantity"]')?.value) || 1);
      const inCart = this.cart.items.some(item => item.variant_id === id);
      const total = Math.max(0, this.cart.total_price + (inCart ? 0 : variant.price * quantity));
      const remaining = Math.max(0, 10000 - total);
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: 'AUD', currencyDisplay: 'narrowSymbol' });
      const message = this.querySelector('[data-shipping-message]');
      message.textContent = remaining ? `Spend another ${formatter.format(remaining / 100)} to receive free shipping` : 'Free Standard shipping reached';
      this.querySelector('[data-shipping-context]').textContent = inCart ? 'Your cart' : (quantity > 1 ? `With ${quantity} of this item` : 'With this item');
      const bar = this.querySelector('[role="progressbar"]');
      bar.setAttribute('aria-valuenow', String(Math.min(total, 10000)));
      bar.setAttribute('aria-valuetext', remaining ? `${formatter.format(remaining / 100)} remaining` : 'Threshold reached');
      bar.firstElementChild.style.width = `${Math.min(total / 100, 100)}%`;
    }
    disconnectedCallback() {
      this.abort?.abort(); this.unsubscribeCart?.(); this.unsubscribeVariant?.(); this.ready = false;
    }
  });
}
